import { Box, FormHelperText } from '@mui/material';
import React from 'react';

import { SectionLabel } from './SectionLabel';
import { RichTextEditor } from '../../../../components/atoms/RichTextEditor';

export interface NotesFieldProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string;
  locked?: boolean;
}

const NOTES_ID = 'create-job-notes-editor';
const NOTES_ERROR_ID = 'create-job-notes-error';

export const NotesField: React.FC<NotesFieldProps> = ({
  value,
  onChange,
  required,
  error,
  locked,
}) => (
  <SectionLabel label="Notes" required={required} locked={locked}>
    <Box sx={{ '& .ql-editor': { minHeight: '120px' } }}>
      <RichTextEditor
        value={value}
        onValueChange={onChange}
        placeholder="Add context for this service (optional)"
        error={!!error}
        htmlId={NOTES_ID}
        ariaLabel="Notes"
        ariaDescribedBy={error ? NOTES_ERROR_ID : undefined}
      />
    </Box>
    {error && (
      <FormHelperText error id={NOTES_ERROR_ID} sx={{ mx: 0 }}>
        {error}
      </FormHelperText>
    )}
  </SectionLabel>
);
